// extracted by mini-css-extract-plugin
export default {"parent":"serchItem_parent__N-ORN","main":"serchItem_main__oatH6","tasks":"serchItem_tasks__AAXek"};